import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableCellHead,
  TableHead,
  TableRow,
} from '~/ui/Table';
import HandsetIcon from '~/assets/svg/newSvg/handset.svg?react';
import { Link } from 'react-router-dom';

interface ITableProps {
  sort: { field: string; direction: string };
  setSort: (sort: { field: string; direction: string }) => void;
  data: {
    id: number;
    user_id: number;
    score: number;
    user: {
      patronymic: string;
      name: string;
      full_name: string;
      id: number;
      code: number;
    };
  }[];
}

const TournamentLeaderboardTable = ({ sort, setSort, data }: ITableProps) => {
  const { t } = useTranslation();
  return (
    <Table>
      <TableHead sort={sort} setSort={setSort}>
        <TableCellHead key={1} field="id">
          {t('employee')}
        </TableCellHead>
        <TableCellHead key={2} field="phone" sortable={false}>
          {''}
        </TableCellHead>
        <TableCellHead key={3} field="score">
          {t('sum_points')}
        </TableCellHead>
      </TableHead>
      <TableBody>
        {data.map(item => (
          <TableRow key={item.id}>
            <TableCell>{`${item.user.full_name} ${
              item.user.code ? item.user.code : ''
            }`}</TableCell>
            <TableCell>
              {
                <Link to={`/user/${item.user_id}`}>
                  <HandsetIcon />
                </Link>
              }
            </TableCell>
            <TableCell>{item.score}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default TournamentLeaderboardTable;
